<template>
  <el-dialog
    :title="!dataForm.id ? '新增' : '修改'"
    :modal-append-to-body="false"
    :show-close="false"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmit()"
             label-width="80px">
      <el-form-item label="中文名称" prop="chineseName">
        <el-input v-model="dataForm.chineseName" placeholder="中文名称"></el-input>
      </el-form-item>
      <el-form-item label="英文名称" prop="englishName">
        <el-input v-model="dataForm.englishName" placeholder="英文名称"></el-input>
      </el-form-item>
      <el-form-item label="编码" prop="code">
        <el-input v-model="dataForm.code" placeholder="编码"></el-input>
      </el-form-item>
      <el-form-item label="计量单位" prop="unit">
        <el-input v-model="dataForm.unit" placeholder="计量单位"></el-input>
      </el-form-item>
      <el-form-item label="排放量" prop="emissionUnit">
        <el-input v-model="dataForm.emissionUnit" placeholder="计量单位（排放量）"></el-input>
      </el-form-item>
      <el-form-item label="数据类型" prop="dataType">
        <el-input v-model="dataForm.dataType" placeholder="数据类型"></el-input>
      </el-form-item>
      <el-form-item label="第一预警" prop="firstAlarmValue">
        <el-input v-model="dataForm.firstAlarmValue" placeholder="第一预警值"></el-input>
      </el-form-item>
      <el-form-item label="第二预警" prop="secondAlarmValue">
        <el-input v-model="dataForm.secondAlarmValue" placeholder="第二预警值"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
      <el-button type="primary" @click="dataFormSubmit()">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      dataForm: {
        id: 0,
        chineseName: '',
        englishName: '',
        code: '',
        unit: '',
        emissionUnit: '',
        dataType: '',
        firstAlarmValue: '',
        secondAlarmValue: ''
      },
      dataRule: {
        chineseName: [
          {required: true, message: '中文名称不能为空', trigger: 'blur'}
        ],
        code: [
          {required: true, message: '编码不能为空', trigger: 'blur'}
        ],
      }
    }
  },
  methods: {
    init(id) {
      this.dataForm.id = id || 0
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.$http({
            url: this.$http.adornUrl(`/configFactor/list`),
            method: 'get',
            params: this.$http.adornParams({
              'pageNum': 1,
              'pageSize': 1,
              'id': id
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.dataForm = data.data.rows[0]
            }
          })
        }
      })
    },
    // 表单提交
    dataFormSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.$http({
            url: this.$http.adornUrl(`/configFactor/${!this.dataForm.id ? 'save' : 'update'}`),
            method: 'post',
            data: this.$http.adornData({
              'id': this.dataForm.id || undefined,
              'chineseName': this.dataForm.chineseName,
              'englishName': this.dataForm.englishName,
              'code': this.dataForm.code,
              'unit': this.dataForm.unit,
              'emissionUnit': this.dataForm.emissionUnit,
              'dataType': this.dataForm.dataType,
              'firstAlarmValue': this.dataForm.firstAlarmValue,
              'secondAlarmValue': this.dataForm.secondAlarmValue
            })
          }).then(({data}) => {
            if (data && data.code === 200) {
              this.$emit('refreshDataList')
              this.visible = false
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1000,
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/parameters/configfactor-add-or-update.vue